export interface CityData {
  name: string;
  lat: number;
  lng: number;
}

export interface LocationData {
  slug: string;
  name: string;
  state: string;
  /** Full display label used in navigation and headings */
  label: string;
  region: string;
  description: string;
  highlights: string[];
  content: string[];
  isPrimary: boolean;
  lat: number;
  lng: number;
  cities: CityData[];
}

export const locations: LocationData[] = [
  {
    slug: "dillon-summit-county",
    name: "Dillon",
    state: "CO",
    label: "Dillon, Colorado, USA",
    region: "Summit County",
    isPrimary: true,
    lat: 39.6303,
    lng: -106.0434,
    description:
      "Our home base. Summit Neighbor Fencing Co. proudly serves Dillon and the surrounding Summit County communities with professional fence installation, repair, and custom fencing built for the high country.",
    highlights: [
      "Locally based right here in Dillon, CO",
      "Fencing engineered for high-altitude weather",
      "Free, no-pressure on-site estimates",
      "Serving a 30-mile radius across Summit County",
    ],
    content: [
      "Dillon sits in the heart of Summit County, where deep snow, high winds, and freeze-thaw cycles are hard on any fence. That's exactly why local homeowners and businesses call Summit Neighbor Fencing Co. — we build fences that are set to depth, squared to slope, and finished with materials chosen to survive mountain conditions.",
      "Whether you need a privacy fence for a Dillon home, a chain link enclosure for a pet area, a picket fence for curb appeal, or perimeter fencing for a build, we handle the layout, install, and clean-up from start to finish.",
      "As a local company, we're quick to respond, easy to reach, and genuinely invested in doing right by our neighbors. Every project begins with a free, no-pressure estimate so you know exactly what to expect.",
    ],
    cities: [
      { name: "Silverthorne", lat: 39.6297, lng: -106.0715 },
      { name: "Frisco", lat: 39.5744, lng: -106.0973 },
      { name: "Breckenridge", lat: 39.4817, lng: -106.0384 },
      { name: "Keystone", lat: 39.6047, lng: -105.9436 },
      { name: "Copper Mountain", lat: 39.5008, lng: -106.1508 },
      { name: "Dillon Valley", lat: 39.6336, lng: -106.0561 },
      { name: "Summit Cove", lat: 39.6208, lng: -106.0206 },
      { name: "Blue River", lat: 39.4247, lng: -106.0428 },
      { name: "Montezuma", lat: 39.5808, lng: -105.8672 },
      { name: "Heeney", lat: 39.8397, lng: -106.2036 },
      { name: "Vail", lat: 39.6403, lng: -106.3742 },
    ],
  },
];
